var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M1.83334 4.66667H13.5C14.1417 4.66667 14.6667 5.19167 14.6667 5.83333C14.6667 6.475 14.1417 7 13.5 7H1.83334C1.19167 7 0.666672 6.475 0.666672 5.83333C0.666672 5.19167 1.19167 4.66667 1.83334 4.66667ZM1.83334 0H13.5C14.1417 0 14.6667 0.525 14.6667 1.16667C14.6667 1.80833 14.1417 2.33333 13.5 2.33333H1.83334C1.19167 2.33333 0.666672 1.80833 0.666672 1.16667C0.666672 0.525 1.19167 0 1.83334 0ZM1.83334 9.33333H8.83334C9.47501 9.33333 10 9.85833 10 10.5C10 11.1417 9.47501 11.6667 8.83334 11.6667H1.83334C1.19167 11.6667 0.666672 11.1417 0.666672 10.5C0.666672 9.85833 1.19167 9.33333 1.83334 9.33333ZM12.3333 10.36V15.295C12.3333 15.75 12.8233 16.03 13.22 15.7967L17.3383 13.3233C17.7117 13.1017 17.7117 12.5533 17.3383 12.32L13.22 9.84667C12.8233 9.625 12.3333 9.905 12.3333 10.36Z",
  fill: "white"
});

var SvgIconPlaylist = function SvgIconPlaylist(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPlaylist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-playlist.e85f2f42.svg";
export { ForwardRef as ReactComponent };